module.exports = __webpack_public_path__ + "img/nfc.0544267b.png";